import { useTranslation } from 'react-i18next';
import { MouseEvent } from 'react';
import { FormInput } from 'ui/FormComponents';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRotateLeft } from '@fortawesome/free-solid-svg-icons';
import DeleteIcon from 'assets/icons/delete.svg?react';
import { useFormContext } from 'react-hook-form';
import { EditOutlined } from '@mui/icons-material';
export interface ActionHeaderProps {
  index?: number;
  isDisabled: boolean;
  isActionOpen: boolean;
  isDeleted: boolean;
  isStepRequired: boolean;
  deleteAction: (e: MouseEvent<HTMLElement>) => void;
}
export const ActionHeader = ({
  index,
  isDisabled,
  isActionOpen,
  isDeleted,
  deleteAction,
  isStepRequired,
}: ActionHeaderProps) => {
  const { t } = useTranslation();
  const fieldName = index !== undefined ? `actions.${index}.` : '';
  const { getValues } = useFormContext();
  const currentActionStatus = getValues(`${fieldName}status`);
  return (
    <div className="single-action-wrapper">
      <div className="action-title-wrapper">
        <FormInput
          placeHolderText={t('case:placeholders.actionTitle')}
          maxLength={80}
          fullWidth
          isRequired={false}
          disabled={isDisabled}
          name={`${fieldName}name`}
          classname="action-title"
          icon={<EditOutlined />}
          required={isStepRequired}
          variant="borderless"
        />
      </div>

      <div className="action-header-right-info">
        {isDeleted ? (
          <p className="action-deleted">{t('case:deleted')}</p>
        ) : (
          <span className={currentActionStatus}>
            {t(`case:actions.status.${currentActionStatus}`)}
          </span>
        )}
        {isActionOpen && (
          <div
            className="case-delete-icon"
            onClick={deleteAction}
            role="button"
            tabIndex={0}
            aria-label="Delete action"
          >
            {isDeleted ? (
              <FontAwesomeIcon icon={faRotateLeft} className="action-deleted-icon" />
            ) : (
              <DeleteIcon type="button" aria-label="delete action" tabIndex={0} />
            )}
          </div>
        )}
      </div>
    </div>
  );
};
